/* step 2 of mobile verification, entering the code */
<template>
  <div v-if="!getLoadingBoolean">
    <h2>{{ $t('message.common.mobileVerification.title') }}</h2>
    <p class="col-sm-10 pl-0">
      {{ $t('message.common.mobileVerification.codeText[0]') }}&nbsp;{{ formattedPhoneNumber
      }}{{ $t('message.common.mobileVerification.codeText[1]') }}
    </p>
    <mobialis-form-with-validation
      @onValidate="verify"
      v-av-analytics-form-submit="{
        elementText: $t('message.common.mobileVerification.verify'),
        invalid: this.errorMsg !== '',
      }"
    >
      <MobialisTextInputWithValidation
        class="col-12 col-sm-7 pl-0"
        rules="required"
        vid="code"
        v-model="code"
        :label="$t('message.common.mobileVerification.verificationCode')"
        data-cy="code"
      ></MobialisTextInputWithValidation>

      <small class="errorMsg" :key="errorMsg">{{ errorMsg }}</small>
      <small>
        {{ $t('message.common.mobileVerification.noGetCode') }} &nbsp; &nbsp;
        <span
          class="resendCode font-weight-bold"
          @click="resendCode()"
          v-av-analytics-cta-interaction="{
            elementText: $t('message.common.mobileVerification.resendCode'),
            eventActionResult: 'open',
          }"
          >{{ $t('message.common.mobileVerification.resendCode') }}</span
        >
      </small>
      <mobialis-button type="submit" class="verifyButton" data-cy="verifyCode">{{
        $t('message.common.mobileVerification.verify')
      }}</mobialis-button>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Code',
  data() {
    return {
      errorMsg: '',
      code: '',
    };
  },
  mounted() {
    this.$store.commit('SET_LOADING', false);
  },
  computed: {
    ...mapGetters('user', ['getPhoneNumber']),
    ...mapGetters(['getLoadingBoolean', 'getProductHomeState', 'getCurrentProduct']),
    formattedPhoneNumber() {
      const number = this.getPhoneNumber;
      const countryCode = number.slice(0, 2);
      const areaCode = number.slice(2, 5);
      const prefix = number.slice(5, 8);
      const lineNumber = number.slice(8, 12);
      return `${countryCode}(${areaCode})-${prefix}-${lineNumber}`;
    },
  },
  methods: {
    resendCode() {
      this.$router.push('mobile-verification');
    },
    async verify(isValid) {
      if (!isValid) {
        return;
      }

      try {
        this.$store.commit('SET_LOADING', true);
        const res = await this.$store.dispatch('user/verifyCode', this.code);
        const { verified } = res.data;
        if (verified) {
          try {
            await this.$store.dispatch('lead/updateLead');
            this.$router.push({ path: `${this.getProductBasePath()}/report` });
          } catch (error) {
            this.$log(`Error in ${this.$route.path} - Update Lead`, error);
            this.$router.push({ path: `${this.getProductBasePath()}/error` });
          }
        } else {
          this.errorMsg = this.$t('message.common.mobileVerification.codeErrorText');
        }
      } catch (error) {
        this.errorMsg = this.$t('message.common.mobileVerification.codeErrorText');
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';
small {
  font-size: 14px;
}
.errorMsg {
  color: #cc0000;
  display: block;
}
.resendCode {
  display: inline-block;
  color: $primary;
  cursor: pointer;
  font-size: 14px;
}
h2 {
  font-size: 22px;
  font-weight: bold;
}
.verifyButton {
  margin-top: 50px;
}
</style>
